import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import ImageThumbHtmlView from './ImageHtml';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
const ImageThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ImageThumbHtmlView, _extends({}, props));
    }
    /* In editor we make the background transparent to avoid overlapping with custom backgrounds */ return /*#__PURE__*/ React.createElement(MinimalDumbo, _extends({
        useBackgroundColor: false
    }, props));
};
ImageThumbView.displayName = 'ImageThumbView';
export default ImageThumbView;
